











import {Component, Vue} from 'vue-property-decorator';
import AppBase from '@/components/AppBase.vue';
import MyTrainItem from '@/components/MyTrainItem.vue';
import {Observer} from 'mobx-vue';
import {trainStore, engine} from '@/data/train-store';

@Observer
@Component({
  components: {AppBase, MyTrainItem}
})
export default class MyTrains extends Vue {
  private store = trainStore;
}
